import { useMutation, useQueryClient } from '@tanstack/vue-query';
import httpClient from '../httpClient';
import type { MantaClient } from '@/types';

export interface UpdateClientPayload {
  first_name?: string | null;
  last_name?: string;
  phone_number?: string | null;
  email?: string | null;
}

/** Updates an internally-managed client in manta (via the scribe-backend proxy). */
export const useClientUpdate = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({
      id,
      data,
    }: {
      id: string;
      data: UpdateClientPayload;
    }): Promise<MantaClient> => {
      const response = await httpClient.patch<MantaClient>(
        `/v1/clients/${id}`,
        data,
      );
      return response.data;
    },
    onSuccess: (updated) => {
      queryClient.setQueryData(['scribeClient', updated.id], updated);
      void queryClient.invalidateQueries({ queryKey: ['scribeClientSearch'] });
    },
  });
};
